import Vue from 'vue'

const dateString = function (dateString) {
  const options = {}
  options.year = options.month = options.day = options.hour = options.minute = options.second = 'numeric'

  const date = new Date(dateString)
  const format = new Intl.DateTimeFormat('fo', options).format(date)
  return format.split(', ')
}

const plugin = function (Vue, options) {
  Vue.prototype.$dateString = dateString
  Vue.$dateString = dateString
}

Vue.use(plugin)
